import React from 'react'
import { connect } from 'react-redux'
import Wrapper from './WidgetCardWrapper'
import { translate } from 'react-i18next'
import { DATASOURCE } from 'Constants'
import BaseWidget from './BaseWidget'
import DonutChart from 'components/DonutChart'

class DevicesPie extends BaseWidget {
  constructor(props) {
    super(props,DATASOURCE.SUMMARY);
  }

  static defaultGridItemProps(){
    return {
      w: 4,
      h: 12,
      maxW: 6,
      maxH: 16
    };
  }

  render() {
    return (
      <Wrapper {...this.props}
        isLoading={this.props.summary.loading}
      >
        <DonutChart
          decimals={0}
          series={this.props.summary.agentSeries}
          drilldown={this.props.summary.agentDrilldown}
        />
      </Wrapper>
    );
  }
}

// Helper functions
const mapToProps = state => {
  return {
    summary: state.summary,
    history: state.router
  }
};
        
export default translate()(
  connect(
    mapToProps,
    null
  )(DevicesPie)
);

